<template>
    <div class="filter-block">
        <div class="row">
            <div class="col">
                <h3>Configure your pricing</h3>
                <div class="row filter-block__form">
                    <div class="col-12 col-lg">
                        <div class="form-group">
                            <div class="text-nowrap">
                                <label class="form-label" for="term">Term</label>
                                <span class="info" tabindex="-1"
                                      id="term-tt"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><g fill="none" fill-rule="nonzero"><circle cx="11" cy="11" r="10.214" fill="#FFF" stroke="#66E4EE" stroke-width="1.571"/><path fill="#004666" d="M10 8h2v10h-2zM10 4h2v2h-2z"/></g></svg></span>
                            </div>
                            <b-popover :target="`term-tt`" :placement="`top`" triggers="hover focus">
                                <p> Choose term in months.</p>
                            </b-popover>
                            <div class="pretty-select">
                                <select id="term" v-model="term">
                                    <option v-for="singleTerm in availableTerms" :value="singleTerm" :key="singleTerm">{{singleTerm}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg">
                        <div class="form-group">
                            <div class="d-flex">
                                <div class="text-nowrap">
                                    <label class="form-label" for="advance">Advance rentals</label>
                                    <span class="info" tabindex="-1"
                                          id="advance-tt"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><g fill="none" fill-rule="nonzero"><circle cx="11" cy="11" r="10.214" fill="#FFF" stroke="#66E4EE" stroke-width="1.571"/><path fill="#004666" d="M10 8h2v10h-2zM10 4h2v2h-2z"/></g></svg></span>
                                </div>
                            </div>
                            <b-popover :target="`advance-tt`" :placement="`top`" triggers="hover focus">
                                <p>A higher number reduces your monthly payment.</p>
                            </b-popover>
                            <div class="pretty-select">
                                <select id="advance" v-model="advance">
                                    <option v-for="singleAdvance in availableAdvance" :value="singleAdvance" :key="singleAdvance">{{singleAdvance}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg">
                        <div class="form-group">
                            <div class="text-nowrap">
                                <label class="form-label" for="mileage">Mileage</label>
                                <span class="info" tabindex="-1"
                                      id="mileage-tt"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><g fill="none" fill-rule="nonzero"><circle cx="11" cy="11" r="10.214" fill="#FFF" stroke="#66E4EE" stroke-width="1.571"/><path fill="#004666" d="M10 8h2v10h-2zM10 4h2v2h-2z"/></g></svg></span>
                            </div>
                            <b-popover :target="`mileage-tt`" :placement="`top`" triggers="hover focus">
                                <p>Select your annual mileage</p>
                            </b-popover>
                            <div class="pretty-select">
                                <select id="mileage" v-model="mileage">
                                    <option v-for="singleMileage in availableMileage" :value="singleMileage" :key="singleMileage">
                                        {{singleMileage | numberFormat}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg">
                        <div class="text-nowrap">
                            <label class="form-label">Include&nbsp;maintenance?</label>
                            <span class="info" tabindex="-1"
                                  id="maint-tt"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><g fill="none" fill-rule="nonzero"><circle cx="11" cy="11" r="10.214" fill="#FFF" stroke="#66E4EE" stroke-width="1.571"/><path fill="#004666" d="M10 8h2v10h-2zM10 4h2v2h-2z"/></g></svg></span>
                        </div>
                        <b-popover :target="`maint-tt`" :placement="`top`" triggers="hover focus">
                            <p>Allows you to spread maintenance costs evenly across the year.</p>
                        </b-popover>
                        <div class="pretty-radio">
                            <label :for="`yes`" class="label label--radio d-inline-block">
                                <input type="radio"
                                       :id="`yes`"
                                       v-model="maintenance"
                                       :name="`vehicle-select`"
                                       :value="true"
                                       class="input input--radio"/>
                                <span class="pretty-radio__check">Yes</span>
                            </label>
                            <label :for="`no`" class="label label--radio d-inline-block">
                                <input type="radio"
                                       :id="`no`"
                                       v-model="maintenance"
                                       :name="`vehicle-select`"
                                       :value="false"
                                       class="input input--radio"/>
                                <span class="pretty-radio__check">No</span>
                            </label>
                        </div>
                    </div>
<!--                    <div class="col-12 col-lg-2">-->
<!--                        <div class="form-group filter-block__form__button-wrap">-->
<!--                            <button :class="['button', details ? 'button&#45;&#45;solid':'button&#45;&#45;ghost-white']" @click="update()">Update</button>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {FINANCE_FILTER_MILEAGE, FINANCE_FILTER_MAINT, FINANCE_FILTER_TERM, FINANCE_FILTER_ADVANCE} from "../../store/mutation-types";

    export default {
        name: "FilterBlock",
        props: [
            "details"
        ],
        data: function() {
            return {
                availableTerms: [24, 36, 48],
                availableAdvance: [1, 3, 6, 9],
                availableMileage: [10000, 15000, 20000, 25000, 30000],
            }
        },
        computed: {
            maintenance: {
                get: function() {
                    return this.$store.state.FINANCE_FILTER_MAINT;
                },
                set: function(value) {
                    this.$store.commit(FINANCE_FILTER_MAINT, value);
                }
            },
            mileage: {
                get: function() {
                    return this.$store.state.FINANCE_FILTER_MILEAGE;
                },
                set: function(value) {
                    this.$store.commit(FINANCE_FILTER_MILEAGE, value);
                }
            },
            term: {
                get: function() {
                    return this.$store.state.FINANCE_FILTER_TERM;
                },
                set: function(value) {
                    this.$store.commit(FINANCE_FILTER_TERM, value);
                }
            },
            advance: {
                get: function() {
                    return this.$store.state.FINANCE_FILTER_ADVANCE;
                },
                set: function(value) {
                    this.$store.commit(FINANCE_FILTER_ADVANCE, value);
                }
            },
        },
        methods: {
            update: function() {
                this.$emit('updateFinance');
            }
        }
    }
</script>

<style scoped lang="stylus">
    .filter-block
        background-color #f3f3f3
        padding 0 20px
        h3
            margin-top 15px
            margin-bottom 20px
        &__form
            margin-bottom 10px
            &__button-wrap
                margin-top 34px
            .pretty-select
                border solid 1px #a8adb3
                background-color #fff
                &:after
                    background-image url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='9' viewBox='0 0 15 9'%3E%3Cpath fill='%23004666' fill-rule='nonzero' d='M1.588.03l5.883 5.882L13.41-.03l1.56 1.558-7.5 7.5L.029 1.59 1.59.028z'/%3E%3C/svg%3E")
                    background-color transparent
                    background-repeat no-repeat
                    background-position 50% 50%
            .pretty-radio
                flex 0 0 100%
                display flex
                justify-content flex-start
                align-items center
                padding 9px 0
                @media (max-width 767px)
                    flex-wrap wrap
                    margin-bottom 1rem

                &__title
                    margin-right 1.5rem

                    @media (max-width 767px)
                        flex 0 0 100%
                        margin-bottom 5px
                &__check
                    &:before
                        background-color #ffffff

                .paragraph
                    margin-right 2.5rem
                    display: inline-block
                    margin-bottom 0

                .label--radio
                    flex 0 0 auto
                    max-width unset
                    display flex
                    position relative
                    overflow hidden
                    flex-direction row
                    justify-content flex-start
                    align-items center
                    padding-left 3.5rem
                    padding-right 0
                    cursor pointer
                    margin 0

                    &:not(:last-child)
                        margin-right 4.5rem

                    .input
                        position absolute
                        left -9999em
                        max-width auto
                        width auto

                    // check markers

                    span
                        &:before
                            display block
                            position absolute
                            left 0
                            top 50%
                            transform translateY(-50%)
                            content ''
                            width 2.4rem
                            height 2.4rem
                            border solid 1px #a8adb3
                            box-shadow none
                            border-radius 50%
                            cursor pointer

                    .input:checked + span
                        &:after
                            display block
                            position absolute
                            left 5px
                            top 50%
                            transform translateY(-50%)
                            content ''
                            width 1.4rem
                            height 1.4rem
                            box-shadow none
                            background-color #004666
                            border-radius 50%
                            cursor pointer
</style>